/**
 * 大会的默认通用信息
 */

export default {
  websiteTitle: '全球架构师峰会',
  websiteTitleEN: 'ArchSummit',
  keywords: 'ArchSummit,InfoQ,全球架构师峰会',
  logo: {
    pc: require('@/assets/logo-gtlc.svg'),
    mobile: require('@/assets/logo-gtlc.svg')
  },
  // 微信公众号链接
  WeChatOfficialAccounts: require('@/assets/img/qrcode-as.png')
}
